import { motion } from "framer-motion";
import { IMG, PAGE_CONTENT } from "@/lib/constants";
import MagneticButton from "@/components/MagneticButton";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="pt-40 pb-16 max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <div className="font-display text-[11px] uppercase tracking-[0.4em] text-copper mb-5">{PAGE_CONTENT.about.hero.kicker}</div>
          <h1 className="font-serif text-6xl md:text-8xl leading-[0.9] tracking-tighter max-w-5xl">
            {PAGE_CONTENT.about.hero.title1} <em className="italic font-light text-copper">{PAGE_CONTENT.about.hero.title2}</em> {PAGE_CONTENT.about.hero.title3}
          </h1>
        </motion.div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-24 grid lg:grid-cols-12 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.9 }} className="lg:col-span-6"
        >
          <div className="aspect-[4/5] border border-line overflow-hidden">
            <img src={IMG.team} alt="team" className="w-full h-full object-cover kenburns-img" />
          </div>
        </motion.div>

        <div className="lg:col-span-6 space-y-8">
          <p className="font-serif italic text-3xl leading-snug text-parchment">
            {PAGE_CONTENT.about.story.quote}
          </p>
          <p className="text-parchment/75 leading-relaxed">
            {PAGE_CONTENT.about.story.p1}
          </p>
          <p className="text-parchment/75 leading-relaxed">
            {PAGE_CONTENT.about.story.p2}
          </p>
          <p className="text-parchment/75 leading-relaxed">
            {PAGE_CONTENT.about.story.p3}
          </p>
          <div className="pt-6">
            <MagneticButton as="a" href="/contact" testId="about-cta">Start a Conversation</MagneticButton>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24 border-t border-line grid md:grid-cols-3 gap-10" data-testid="about-values">
        {PAGE_CONTENT.about.values.map((v, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.8 }}
            className="p-8 border-t border-copper/40"
          >
            <div className="font-display text-[10px] uppercase tracking-[0.3em] text-copper mb-4">Value {String(i + 1).padStart(2, "0")}</div>
            <h3 className="font-serif text-4xl mb-4 tracking-tight">{v.t}</h3>
            <p className="text-parchment/70">{v.d}</p>
          </motion.div>
        ))}
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20 border-t border-line">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {PAGE_CONTENT.about.stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="border-l border-copper pl-5"
            >
              <div className="font-serif text-5xl md:text-6xl">{s.k}</div>
              <div className="font-display text-[10px] uppercase tracking-[0.3em] text-muted2 mt-2">{s.l}</div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
